import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form'
import { FormItemProps, RadioChangeEvent, RadioGroupProps } from 'antd'

import { RadioButtonGroup } from 'Shared/atoms'

import { FieldNameRegexType } from 'Core/interfaces'

type FormRadioButtonGroupProps<FieldsType extends FieldValues> = RadioGroupProps &
	FormItemProps & {
		control: Control<FieldsType>
		fieldName: keyof FieldsType | FieldNameRegexType
	}

function FormRadioButtonGroup<FieldsType extends FieldValues>({
	control,
	fieldName,
	optionType,
	onChange,
	...props
}: FormRadioButtonGroupProps<FieldsType>) {
	return (
		<Controller
			name={fieldName as FieldPath<FieldsType>}
			control={control}
			render={({ field: { onChange: onReactHookChange, ...rest } }) => {
				const onChangeRadio = (e: RadioChangeEvent) => {
					onReactHookChange(e)
					onChange()
				}
				return (
					<RadioButtonGroup
						{...props}
						{...rest}
						onChange={onChangeRadio}
						optionType={optionType}
					/>
				)
			}}
		/>
	)
}

export default FormRadioButtonGroup
